import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input, Textarea } from "rbx";

import { LocationSelect, DirectionsInput } from "../inputs";

const DirectionForm = ({ inputs, onChange }) => (
  <React.Fragment>
    <Field kind="group">
      <Control expanded>
        <LocationSelect
          icon="globe"
          label="Origin Location"
          name="OriginLocationRecIdRef"
          value={inputs.OriginLocationRecIdRef}
          valueKey="RecId"
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <LocationSelect
          icon="globe"
          label="Destination Location"
          name="DestinationLocationRecIdRef"
          value={inputs.DestinationLocationRecIdRef}
          valueKey="RecId"
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Priority</Label>
        <Input
          name="Priority"
          type="text"
          value={inputs.Priority}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field kind="group">
      <Control expanded>
        <Label>Miles</Label>
        <Input
          autocomplete="new"
          name="LoadedMiles"
          type="number"
          value={inputs.LoadedMiles}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Loaded Travel Time</Label>
        <Input
          autocomplete="new"
          name="LoadedTravelTime"
          type="number"
          value={inputs.LoadedTravelTime}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Empty Travel Time</Label>
        <Input
          autocomplete="new"
          name="EmptyTravelTime"
          type="number"
          value={inputs.EmptyTravelTime}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Loading Time</Label>
        <Input
          autocomplete="new"
          name="LoadingTime"
          type="number"
          value={inputs.LoadingTime}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Unloading Time</Label>
        <Input
          autocomplete="new"
          name="UnloadingTime"
          type="number"
          value={inputs.UnloadingTime}
          onChange={onChange}
        />
      </Control>
    </Field>

    <Field>
      <Control expanded>
        {/* <Label>Directions</Label> */}
        <DirectionsInput
          destination={inputs.DestinationLocationRecIdRef}
          name="Directions"
          origin={inputs.OriginLocationRecIdRef}
          value={inputs.Directions}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field>
      <Label>Special Instructions</Label>
      <Control expanded>
        <Textarea
          autoComplete="new"
          name="SpecInstr"
          type="text"
          value={inputs.SpecInstr}
          onChange={onChange}
        />
      </Control>
    </Field>
  </React.Fragment>
);

DirectionForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};
DirectionForm.defaultProps = {
  inputs: {}
};
export default DirectionForm;
